import { render, staticRenderFns } from "./AdvPortForwardingForm.vue?vue&type=template&id=d5ca2bb2&"
import script from "./AdvPortForwardingForm.vue?vue&type=script&lang=js&"
export * from "./AdvPortForwardingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports